import * as actionTypes from './actionTypes';

interface State {
  data: any;
  isFetching: boolean;
  error: boolean;
  counter: any;
  both: any;
  counterTotal: number;
}

const initialState: State = {
  isFetching: false,
  error: false,
  data: {},
  counter: {},
  both: {},
  counterTotal: 0
};

export const myPackageAvailable = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_MY_PACKAGE_AVAILABLE_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_MY_PACKAGE_AVAILABLE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_MY_PACKAGE_AVAILABLE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    case actionTypes.SET_MY_PACKAGE_AVAILABLE_ALL:
      return {
        ...state,
        counter: action.data
      }
    case actionTypes.SET_MY_PACKAGE_AVAILABLE_BY_CHANNEL:
      const current = {};
      current[action.id] = action.value;
      return {
        ...state,
        counter: {
          ...state.counter,
          ...current
        }
      }
    case actionTypes.SET_MY_PACKAGE_AVAILABLE_TOTAL:
      return {
        ...state,
        counterTotal: action.value
      }
    case actionTypes.CLEAR_MY_PACKAGE_AVAILABLE_ALL:
      return {
        isFetching: false,
        error: false,
        data: {},
        counter: {},
        both: {},
        counterTotal: 0
      }
    case actionTypes.SET_MY_PACKAGE_AVAILABLE_BOTH:
      return {
        ...state,
        both: {
          ...state.both,
          [action.id]: action.quantity
        }
      }
    default:
      return state;
  }
};
